/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-private-classes */
'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'underscore';
import UIList from 'UIComponents/list/UIList';
import UIButton from 'UIComponents/button/UIButton';
import UIFileButton from 'UIComponents/button/UIFileButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import ContextMenuItemGroup from 'DesignData/models/ContextMenuItemGroup';
import UIMedia from 'UIComponents/layout/UIMedia';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';
import UIMediaRight from 'UIComponents/layout/UIMediaRight';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { FILE_UPLOAD_MEDIA_TYPES } from 'DesignData/constants/Files';

class ContextMenuContent extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onClick = (callback, child, evt) => {
      evt.nativeEvent.stopImmediatePropagation();
      callback(evt);

      if (!child) {
        this.props.closeContextMenu();
        return;
      }

      this.props.swapContextMenuContent(evt, child);
    };

    this.renderOptionsGroup = (group, renderSeparator = true) => {
      const {
        options
      } = group;
      const renderedOptions = options.map(this.renderOption);
      const separator = renderSeparator ? /*#__PURE__*/_jsx("hr", {
        className: "separator"
      }) : null;
      return /*#__PURE__*/_jsxs("div", {
        children: [separator, /*#__PURE__*/_jsx(UIList, {
          className: "private-dropdown--list p-all-0",
          children: renderedOptions
        })]
      }, uniqueId('menuGroup'));
    };

    this.renderOption = option => {
      const {
        label,
        callback,
        icon,
        disabled,
        child,
        rightContent,
        tooltip,
        key,
        isFileUpload,
        divider
      } = option;
      let optionButton;
      const customProps = {
        className: 'options p-y-1',
        disabled,
        key: key || label,
        use: 'transparent',
        size: 'extra-small'
      };

      const innerButton = /*#__PURE__*/_jsxs(UIMedia, {
        children: [/*#__PURE__*/_jsx(UIMediaBody, {
          children: /*#__PURE__*/_jsx("span", {
            children: label
          })
        }), /*#__PURE__*/_jsx(UIMediaRight, {
          children: this.renderRightContent(icon, rightContent)
        })]
      });

      if (isFileUpload) {
        optionButton = /*#__PURE__*/_jsx(UIFileButton, Object.assign({}, customProps, {
          accept: FILE_UPLOAD_MEDIA_TYPES,
          multiple: true,
          onChange: (...partialArgs) => this.onClick(callback, child, ...partialArgs),
          children: innerButton
        }));
      } else {
        optionButton = /*#__PURE__*/_jsx(UIButton, Object.assign({}, customProps, {
          onClick: (...partialArgs) => this.onClick(callback, child, ...partialArgs),
          children: innerButton
        }));
      }

      if (!tooltip) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [divider && /*#__PURE__*/_jsx(UIDropdownDivider, {}), optionButton]
        });
      }

      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [isFileUpload && /*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsx(UITooltip, {
          title: tooltip,
          children: optionButton
        })]
      });
    };
  }

  renderIcon(icon) {
    if (!icon) return null;
    return /*#__PURE__*/_jsx(UIIcon, {
      name: icon
    });
  }

  renderRightContent(icon, rightContent) {
    if (icon) return this.renderIcon(icon);
    return rightContent;
  }

  renderOptions() {
    const {
      contextMenuContentData,
      closeContextMenu
    } = this.props;

    if (!contextMenuContentData) {
      return null;
    }

    if (!Array.isArray(contextMenuContentData)) {
      /*
       * Components passed in are responsible for closing the context menu
       *
       * TODO: Refactor context menu to avoid having to clone element, and pass
       * down open/close functions as props.
       *
       */
      const clonedComponent = /*#__PURE__*/cloneElement(contextMenuContentData, {
        closeContextMenu
      });
      return clonedComponent;
    }

    return contextMenuContentData.reduce((options, actions, index) => {
      const menuActions = actions.options.map(action => {
        if (action instanceof ContextMenuItemGroup) {
          return this.renderOptionsGroup(action, index > 0);
        }

        return this.renderOption(action);
      });

      if (index > 0) {
        options.push( /*#__PURE__*/_jsx(UIDropdownDivider, {}, `action-divider-${index}`));
      }

      options.push(menuActions);
      return options;
    }, []);
  }

  render() {
    return /*#__PURE__*/_jsx(UIList, {
      className: "private-dropdown--list",
      children: this.renderOptions()
    });
  }

}

ContextMenuContent.propTypes = {
  closeContextMenu: PropTypes.func.isRequired,
  contextMenuContentData: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.instanceOf(ContextMenuItemGroup)), PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  swapContextMenuContent: PropTypes.func.isRequired
};
export default ContextMenuContent;